import React from "react";
import Link from "next/link";
import { imageSizerString } from "lib/fun";
import { getCompanyShowPath } from "common";

import { ImageWithLoader } from "../../atoms/imageWithLoader";
import logoPlaceholder from "../../../../assets/images/logoPlaceholder.png";
import styles from "./index.module.scss";
import { ClientItem } from "../../../types";

interface Props {
  client: ClientItem;
  small?: boolean;
}

export const CompanyCard: React.NamedExoticComponent<Props> = React.memo(
  ({ client, small }) =>
    !small ? (
      <div
        className={styles.main}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <div className={styles.top}>
          <ImageWithLoader
            className={styles.logoImg}
            fallback={logoPlaceholder}
            src={client.company.logoImageUrl || logoPlaceholder}
          />
          <div className={styles.description}>
            <div className={styles.title}>{client.company.name}</div>
            <div className={styles.industry}>
              {client.company.industry?.name || ""}
            </div>
          </div>
        </div>
        <ImageWithLoader
          className={styles.backgroundImg}
          fallback={logoPlaceholder}
          src={client.company.backgroundImageUrl || logoPlaceholder}
        />
      </div>
    ) : (
      <Link key={client.id} href={getCompanyShowPath(client.id)}>
        <a {...{ "data-e2e": "company-list-company-card" }}>
          <div className={styles.companyImg}>
            <ImageWithLoader
              fallback={logoPlaceholder}
              src={
                `${imageSizerString(
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  client.company.logoImageUrl!,
                  500,
                  500,
                )}` || logoPlaceholder
              }
            />
          </div>
          <div className={styles.companyDescription}>
            <div className={styles.companyTitle}>{client.company.name}</div>
          </div>
        </a>
      </Link>
    ),
);
